import { makeStyles } from "@material-ui/core/styles";
import { fontSize } from "./fonts";

export const useEvaluationComponentStyles = makeStyles((theme) => ({
  contents: {
    marginBottom: 10,
  },
  title: {
    fontSize: fontSize.h2,
    [theme.breakpoints.down("xs")]: {
      fontSize: fontSize.h3,
    },
  },
  navbar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  navigate: {
    textTransform: "unset !important",
    textAlign: "center",
    width: "48%",
    height: 50,
    borderRadius: "50",
    marginBottom: 10,
  },
  whole: {
    marginBottom: 10,
  },
  phonenavlist: {
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
  },
  phonenavtab: {
    height: 45,
    textAlign: "center",
    "&:hover": {
      border: "1.5px solid black",
    },
    color: "white",
    fontWeight: "450",
    justifyContent: "center",
  },
  phoneresultlist: {
    flexDirection: "column",
    overflowY: "auto",
  },
  phoneresultitem: {
    marginTop: 3,
    marginBottom: 3,
    borderRadius: 10,
    backgroundColor: "#EFEAEA",
    cursor: "pointer",
    flexDirection: "column",
    alignItems: "flex-start",
    "&:hover": {
      backgroundColor: "#e5e5e5",
    },
  },
  resize: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  bottom: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginTop: 20,
    justifyContent: "space-between",
  },
  questionmodal: {
    width: "49%",
    display: "flex",
    flexDirection: "column",
  },
  questiontypelist: {
    display: "flex",
    flexDirection: "row",
  },
  questiontype: {
    fontSize: fontSize.h4,
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    height: 40,
    width: "100%",
    cursor: "pointer",
  },
  question: {
    width: "90%",
    backgroundColor: "#F2EEEE",
    borderRadius: 10,
    marginBottom: 10,
    fontSize: fontSize.h4,
    justifyContent: "center",
    textAlign: "center",
    color: "black",
    wordBreak: "break-word",
    cursor: "pointer",
    minHeight: "50",
    fontWeight: "420",
    "&:hover": {
      backgroundColor: "#e5e5e5",
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: fontSize.h5,
    },
  },
  questionarea: {
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
  },
  answermodal: {
    backgroundColor: "white",
    borderRadius: 10,
    width: "49%",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  questionlist: {
    marginTop: 10,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "90%",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "20px",
      borderWidth: "5px",
    },
    "&::-webkit-scrollbar-track-piece": {
      backgroundColor: "#C9C9C9",
      borderRadius: "8px",
      borderColor: "white",
      borderWidth: "2px 7px 2px 7px",
      borderStyle: "solid",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "9px",
      borderColor: "white",
      backgroundColor: "#FF0000",
      borderStyle: "solid",
      borderWidth: "1px 5px 1px 5px",
    },
  },
  imagedesktop: {
    marginLeft: 20,
    maxWidth: "50%",
    maxHeight: "90%",
    borderRadius: 10,
    borderStyle: "solid",
    [theme.breakpoints.only("sm")]: {
      maxWidth: "80%",
      marginRight: 20,
      marginTop: 5,
      marginBottom: 5,
    },
  },
  contentdesktop: {
    fontSize: fontSize.h4,
    wordBreak: "break-word",
    marginRight: 10,
    marginLeft: 10,
    justifyContent: "center",
    alignItems: "baseline",
    display: "flex",
    "&::-webkit-scrollbar": {
      width: "20px",
      borderWidth: "5px",
    },
    "&::-webkit-scrollbar-track-piece": {
      backgroundColor: "#C9C9C9",
      borderRadius: "8px",
      borderColor: "white",
      borderWidth: "2px 7px 2px 7px",
      borderStyle: "solid",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "9px",
      borderColor: "white",
      backgroundColor: "#FF0000",
      borderStyle: "solid",
      borderWidth: "1px 5px 1px 5px",
    },
  },
  answer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.only("sm")]: {
      flexDirection: "column",
    },
  },
  focusedtitle: {
    marginLeft: 5,
    marginRight: 5,
    textAlign: "center",
    fontSize: fontSize.h5,
  },
  modalPaper: {
    width: "80%",
  },
  answerContainer: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "25px",
    paddingRight: "15px",
    wordBreak: "break-word",
    marginRight: 10,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "20px",
      borderWidth: "5px",
    },
    "&::-webkit-scrollbar-track-piece": {
      backgroundColor: "#C9C9C9",
      borderRadius: "8px",
      borderColor: "white",
      borderWidth: "2px 7px 2px 7px",
      borderStyle: "solid",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "9px",
      borderColor: "white",
      backgroundColor: "#FF0000",
      borderStyle: "solid",
      borderWidth: "1px 5px 1px 5px",
    },
  },
  answerText: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
}));
